import React, { useMemo } from 'react';
import { FilterProvider } from '../../context/Filter.context';
import { SortProvider } from '../../context/Sort.context';
import '../Common/styles.css';
import { useUserPermit } from '../../context/User.context';
import { ActionsProvider } from '../../context/Actions.context';
import { GenreControllerProvider } from '../../context/GenreController.context';
import getFilter from '../Common/utils/getFilter';
import { AO3Endpoints } from '../../core/constants';
import { ISource } from '../Common/types/types';
import AO3Section from './Ao3.section';

const getTabId = (endpoint: string): string => {
  const tabId = Object.keys(AO3Endpoints).find(
    (key) => AO3Endpoints[key] === `/${endpoint}`
  ) as string;

  return tabId;
};

const AO3SectionWrapper: React.FC<ISource> = React.memo((source) => {
  const { role, default_filters: userDefaultFilters } = useUserPermit();
  const search = useMemo(
    () => getFilter({ getTabId, userRole: role, userDefaultFilters }),
    [getTabId, role, userDefaultFilters]
  );

  return (
    <FilterProvider filter={search.filter}>
      <SortProvider sort={search.sort}>
        <ActionsProvider source={source}>
          <GenreControllerProvider>
            <AO3Section />
          </GenreControllerProvider>
        </ActionsProvider>
      </SortProvider>
    </FilterProvider>
  );
});

export default AO3SectionWrapper;